export default __webpack_public_path__ + "static/media/uploader-medtronic6xG-2-2.7c668ffc.png";